import { UC_EVENTS, UC_UI_CMP_EVENT } from '~/plugins/cookieConsent.client';

export interface UsercentricService {
  categorySlug: string;
  consent: {
    status: boolean;
  };
  name: string;
}

type ConsentType = 'functional' | 'marketing' | 'essential' | 'pers-basket' | 'Luigi\'s Box Personalized';
const consents: Ref<UsercentricService[]> = ref([]);

export const useUsercentrics = () => {
  const serviceConsentGiven = (consentType: ConsentType) => {
    // const services: UsercentricService[] = window.UC_UI.getServicesBaseInfo();
    return consents.value.some(({ categorySlug, consent, name }) => ((categorySlug === consentType || name === consentType) && consent.status));
  };

  const isFunctionalConsentGiven = () => serviceConsentGiven('functional');
  const isMarketingConsentGiven = () => serviceConsentGiven('marketing');
  const isEssentialConsentGiven = () => serviceConsentGiven('essential');
  const isPersistBasketConsentGiven = () => serviceConsentGiven('pers-basket');
  const isLuigisBoxPersonalizedConsentGiven = computed(() => serviceConsentGiven('Luigi\'s Box Personalized'));

  const handleEvents = (event: { detail: { type: UC_UI_CMP_EVENT } }) => {
    const { type } = event.detail;

    if (type === UC_UI_CMP_EVENT.ON_SAVE || type === UC_UI_CMP_EVENT.ON_ACCEPT_ALL) {
      consents.value = (window.UC_UI.getServicesBaseInfo() as any[]);
    }
  };
  const handleInit = (event: { type: UC_EVENTS }) => {
    const { type } = event;

    if (type === UC_EVENTS.UI_INITIALIZED) {
      consents.value = (window.UC_UI.getServicesBaseInfo() as any[]);
    }
  };

  if (import.meta.client) {
    window.addEventListener(UC_EVENTS.UI_CMP_EVENT, handleEvents);
    window.addEventListener(UC_EVENTS.UI_INITIALIZED, handleInit);
  }
  return {
    isFunctionalConsentGiven,
    isMarketingConsentGiven,
    isEssentialConsentGiven,
    isPersistBasketConsentGiven,
    isLuigisBoxPersonalizedConsentGiven,
    consents,
  };
};
